import { Component, OnInit, HostListener, Inject, } from '@angular/core';
import { MenuItems } from '../core/menu/menu-items/menu-items';
import { Router } from '@angular/router';
import { ClickOutside } from '../core/directive/click-outside.directive';
import { AuthenticationService } from '../core/services/auth.service';
declare var $: any;

@Component({
  selector: '[angly-menu]',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  selectedLanguage : any = { "label" : "ITA", "code": "it"}
	searchactive: boolean = false;
  @HostListener("window:CallAngularSetLang")
  onCallAngularLng() {
    //console.log(document.querySelector("#google_translate_element select"));
    this.setLanguage('en','ENG');
    console.log('test');
  }
	constructor(public menuItems: MenuItems, public router: Router, private authService: AuthenticationService) { }

	ngOnInit() {}

	searchActiveFunction(){
		this.searchactive = !this.searchactive;
	}
   
	onClickOutside(event:Object) {
    if(event && event['value'] === true) {
      this.searchactive = false;
    }
   }
	
	public removeCollapseInClass() {
      $("#navbarCollapse").removeClass('show');
   }
  public logout() {
    this.authService.logout();
    this.router.navigate(['/home']);
 }

 setLanguage(code,label){
  if(code == 'it') {
    if(document.getElementById(":1.container"))
    (document.getElementById(":1.container") as HTMLIFrameElement)?.contentWindow?.document?.getElementById(":1.close")?.click()
  }
  this.selectedLanguage.label = label;
  this.selectedLanguage.code = code;
  var selectField = document.querySelector("#google_translate_element select") as HTMLSelectElement;
  for (var i = 0; i < selectField.children.length; i++) {
      var option = selectField.children[i];
      // find desired langauge and change the former language of the hidden selection-field
      if ((option as HTMLInputElement).value == code) {
          selectField.selectedIndex = i;
          // trigger change event afterwards to make google-lib translate this side
          selectField.dispatchEvent(new Event('change'));

          break;
      }
  }
 }
}
